export default "__VITE_ASSET__3b61c5d0__"